import { useAdminSession } from "../session";

// Returns the current access token from session
export function useAccessToken() {
    const [{ authToken }] = useAdminSession(["authToken"]);
    return authToken?.access;
}
